<div class="backdrop">
  <div class="pic"></div>
  <div class="form">
    <app-register-form [registerError]="registerError" (submitted)="onSubmit($event)"></app-register-form>
  </div>
</div>
